import Vue from 'vue';
import VuetifyLib from 'vuetify/lib';
import Vuetify from 'vuetify';
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'typeface-roboto/index.css'
import '@fortawesome/fontawesome-free/css/all.css'


Vue.use(Vuetify);

export default new VuetifyLib({
  icons: {
    iconfont: 'md',
  },
  theme: {
    themes: {
      light: {
        primary: '#111113',
        secondary: '#ee0033',
      }
    },
  }

});
